
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { MainLayout } from "@/components/layout/MainLayout";
import { Lock } from "lucide-react";
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { LoginForm } from "@/components/auth/LoginForm";

export function UnauthorizedAccess() {
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  
  return (
    <MainLayout>
      <div className="flex flex-col items-center justify-center py-20 px-4 text-center">
        <div className="bg-muted/50 p-10 rounded-xl border shadow-sm max-w-2xl mx-auto">
          <div className="mx-auto w-16 h-16 mb-6 flex items-center justify-center bg-muted rounded-full">
            <Lock className="h-8 w-8 text-muted-foreground" />
          </div>
          
          <h1 className="text-3xl font-bold tracking-tighter mb-3">Περιεχόμενο μόνο για μέλη</h1>
          
          <p className="text-muted-foreground text-lg mb-6">
            Αυτό το περιεχόμενο είναι διαθέσιμο μόνο για συνδεδεμένα μέλη της Web Star.
            Παρακαλούμε συνδεθείτε για να αποκτήσετε πρόσβαση στο εκπαιδευτικό υλικό.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={() => setShowLoginDialog(true)} 
              className="min-w-32"
            >
              Σύνδεση
            </Button>
            <Button 
              variant="outline" 
              className="min-w-32"
              onClick={() => window.location.href = "/"}
            >
              Επιστροφή στην αρχική
            </Button>
          </div>
        </div>
      </div>

      <Dialog open={showLoginDialog} onOpenChange={setShowLoginDialog}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Σύνδεση</DialogTitle>
          </DialogHeader>
          <LoginForm />
        </DialogContent>
      </Dialog>
    </MainLayout>
  );
}
